import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/system/faqs',
        name: 'faqs_list',
        component: () => import('../views/Faqs.vue'),
        meta: {
            reqAuth: true,
            gate: 'view_faq_list',
        }
    },
    {
        path: '/system/faqs/add',
        name: 'add_faq',
        component: () => import('../views/AddFaqView.vue'),
        meta: {
            reqAuth: true,
            gate: 'add_faq',
        }
    },
    {
        path: '/system/faqs/edit/:uuid',
        name: 'edit_faq',
        component: () => import('../views/EditFaqView.vue'),
        meta: {
            reqAuth: true,
            gate: 'edit_faq',
        }
    }
];

export default routes; 